import React, { useState, useEffect } from 'react'
import { useSummaryFormContext } from '../hook/summary-form'
import { Box, Paper, Text, Divider } from '@mantine/core'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { 
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Font,
  Heading,
  List,
  Alignment,
  Link,
  PasteFromOffice,
  ImageInsertViaUrl,
  Image,
  ImageInsert,  Table, TableToolbar,
  Base64UploadAdapter,
} from 'ckeditor5'

const SummarySupplierNoteProduct = () => {
  const form = useSummaryFormContext()
  const [isLoaded, setIsLoaded] = useState(false)

  const configEditor = {
    plugins:[
      Bold,
      Essentials,
      Italic,
      Mention,
      Paragraph,
      Undo,
      Font,
      Heading,
      List,
      Alignment,
      Link,
      PasteFromOffice,
      ImageInsertViaUrl,
      Image,
      ImageInsert,
      Table, TableToolbar,
      Base64UploadAdapter,
    ],
    alignment: {
      options: [ 'left', 'right' ]
    },
    fontSize: {
      options: [
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22
      ],
      supportAllValues: true
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true
      }
    },
    link: {
      decorators: {
        addTargetToExternalLinks: {
          mode: 'automatic',
          callback: url => /^(https?:)?\/\//.test( url ),
          attributes: {
              target: '_blank',
              rel: 'noopener noreferrer'
          }
        }
      }
    }, 
    toolbar: {
      items: [
        'undo', 'redo',
        '|',
        'heading',
        '|',
        'fontSize', 'Bold', 'Italic', 'alignment',
        '|',
        'link',
        '|',
        'bulletedList', 'numberedList',
        '|',
        'insertImage',
        '|',
        'insertTable'
      ],
      shouldNotGroupWhenFull: true
    },
    initialData: ''
  }

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  const initEditorSupplierNote = () => {
    return (
      <CKEditor
        editor={ClassicEditor}
        config={configEditor}
        data={form.values.note}
        onReady={(editor) => {
          editor.execute('fontSize', { value: '12px' })
          editor.editing.view.change((writer) => {
            writer.setStyle(
              'height',
              '200px',
              editor.editing.view.document.getRoot()
            )
          })
        }}
        onChange={( event, editor ) => {
          editor.execute('fontSize', { value: '12px' })
          const valueEditor = editor.getData()
          form.setFieldValue('note', valueEditor)
        }}
      />
    )
  }

  return (
    <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
      <Text fw={500}>
        Supplier Note
      </Text>

      <Divider my={10} />

      <Box style={{ margin: '20px 0' }}>
        {isLoaded ? initEditorSupplierNote() : ''}
      </Box>
    </Paper>
  )
}

export default SummarySupplierNoteProduct